var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnlockRevenueHeroBackground = function SvgUnlockRevenueHeroBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 760,
    height: 813,
    viewBox: "0 0 760 813",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#613BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BA66D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "89.642%",
    x2: "13.443%",
    y1: "1.527%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".071%",
    stopColor: "#C86DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7A47C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C86DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3927B0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M438.256 116.29c-82.381 168.053-141.859 178.24-313.218 226.933C-77.036 400.645-7.067 736.298 153.422 790.88c297.693 101.245 671.184-157.919 594.802-517.642C716.853 125.491 643.297.823 563.304.801 521.686.79 478.341 34.518 438.256 116.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M125.966 342.765C5.738 376.929-18.912 511.824 15.075 625.659c229.576-37.341 396.174-234.979 398.811-463.113-70.844 123.766-134.09 136.505-287.92 180.219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M489.674 488.399c10.593 84.756 42.863 161.477 90.585 225.328 129.368-95.026 208.777-253.266 168.893-440.949-17.863-84.057-49.838-160.862-88.975-211.208-121.988 100.087-191.518 258.684-170.503 426.829"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnlockRevenueHeroBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unlock-revenue-hero-background.043fc65bcb51a3e30b514c796350df63.svg";